/**
 * Returns the price a customer would pay for this product+variant today.
 * Canonical rule used by ProductCard, ProductPage, CheckoutPage, CartDrawer,
 * ExchangeModal, EditOrderItemsModal, CodOrderForm, and any future price math.
 * - If variant has a non-null price AND it is strictly less than the base price,
 *   use it (genuine variant-level override; redundant variant.price == base is a no-op).
 * - Else if sale_price is set and strictly less than base price, use sale_price.
 * - Else use base price.
 */
export function effectiveUnitPrice(product, variant) {
  if (!product) return 0;
  const base = Number(product.price) || 0;
  if (variant && variant.price != null) {
    const v = Number(variant.price);
    if (!Number.isNaN(v) && v < base) return v;
  }
  const sale = product.sale_price;
  if (sale != null) {
    const s = Number(sale);
    if (!Number.isNaN(s) && s > 0 && s < base) return s;
  }
  return base;
}

/**
 * Returns true if the product+variant currently has an active promo
 * (i.e., effective price is less than base price). Use this for UI
 * indicators like strike-through, badges, etc.
 */
export function hasActiveDiscount(product, variant) {
  if (!product) return false;
  const effective = effectiveUnitPrice(product, variant);
  const base = Number(product.price) || 0;
  return effective < base;
}
